/**
 * Authenticated fetch wrapper for /api/admin/* endpoints used by the new
 * pages (Studio, Reels, Newsletter, Broadcast). Auto-logs out on 401.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export async function adminFetch(path, opts = {}) {
  const token = localStorage.getItem("admin_token");
  const res = await fetch(`${BACKEND_URL}${path}`, {
    ...opts,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {}),
    },
  });
  if (res.status === 401 && !path.includes("/login")) {
    localStorage.removeItem("admin_token");
    if (
      typeof window !== "undefined" &&
      window.location.pathname.startsWith("/admin") &&
      !window.location.pathname.endsWith("/admin/login")
    ) {
      window.location.replace("/admin/login");
    }
    throw new Error("Sesión expirada");
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res;
}

export async function adminFetchJson(path, opts = {}) {
  const res = await adminFetch(path, opts);
  return res.json();
}
